import { render, staticRenderFns } from "./deliver-order-dialog.vue?vue&type=template&id=a970f082&scoped=true&"
import script from "./deliver-order-dialog.vue?vue&type=script&lang=js&"
export * from "./deliver-order-dialog.vue?vue&type=script&lang=js&"
import style0 from "./deliver-order-dialog.vue?vue&type=style&index=0&id=a970f082&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._qkvgvrmvpkafkn37suro37nope/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a970f082",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_gys_admin_online_docker/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a970f082')) {
      api.createRecord('a970f082', component.options)
    } else {
      api.reload('a970f082', component.options)
    }
    module.hot.accept("./deliver-order-dialog.vue?vue&type=template&id=a970f082&scoped=true&", function () {
      api.rerender('a970f082', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nb/order/delivery/components/deliver-order-dialog.vue"
export default component.exports